import React, { forwardRef } from "react";
import { InfoAction, InfoColors, InfoItem } from "./data";
import { useInformationStyles } from "./InformationStyles";

type InformationItemProps = {
  idx: number;
  item: InfoItem;
  onClick: (item: InfoItem) => void;
  modoMayor?: boolean;
};

export const InformationItem = forwardRef<HTMLDivElement, InformationItemProps>(
  function InformationItem({ idx, item, onClick, modoMayor = false }, ref) {
    const classes = useInformationStyles();

    return (
      <div
        ref={ref}
        className={`${classes.item} ${modoMayor ? classes.modoMayorItem : ""}`}
      >
        <button
          className={`${classes.button} ${
            modoMayor ? classes.modoMayorButton : ""
          }`}
          style={{
            backgroundColor: InfoColors[idx % InfoColors.length],
          }}
          onClick={() => onClick(item)}
        >
          <img
            className={`${classes.icon} ${
              modoMayor ? classes.modoMayorIcon : ""
            }`}
            src={item.icon}
            alt={item.label}
          />
        </button>
        <div className={classes.label}>{item.label}</div>
      </div>
    );
  }
);
